/** @format */

import React, { useId } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import ValidityCheck from "./validityCheck";

const SelectInput = ({
  id,
  control,
  options,
  placeholder,
  disabled,
  isLoading,
  isSearchable,
  errors,
  showValidIcon,
  tooltipText,
  onChange,
  ...props
}) => {
  const instanceId = useId();
  const menuPortalTarget =
    typeof document !== "undefined" ? document.body : undefined;

  return (
    <div className="tw-group tw-relative tw-w-full">
      <Controller
        name={id}
        control={control}
        rules={{ required: "Required" }}
        render={({ field }) => (
          <>
            <Select
              unstyled
              isSearchable={isSearchable ?? false}
              onChange={(selectedOption) => {
                field.onChange(selectedOption);
                onChange(selectedOption);
              }}
              {...props}
              menuPortalTarget={menuPortalTarget}
              menuPosition="fixed"
              styles={{
                menu: (baseStyles) => ({ ...baseStyles, zIndex: 9999 }),
                menuPortal: (baseStyles) => ({ ...baseStyles, zIndex: 9999 }),
                singleValue: (baseStyles) => ({
                  ...baseStyles,
                  maxWidth: showValidIcon
                    ? "calc(100% - 48px)"
                    : baseStyles.maxWidth,
                }),
                menuList: (baseStyles) => ({
                  ...baseStyles,
                  maxHeight: 180,
                  overflowY: "auto",
                }),
              }}
              classNames={{
                container: () => "tw-w-full",
                control: () =>
                  `tw-flex tw-h-12 tw-min-h-12 tw-w-full tw-items-center tw-rounded-lg tw-border-0 tw-border-b-2 tw-border-solid tw-pl-[15px] tw-pr-1 ${
                    errors
                      ? "tw-border-dis-error tw-bg-dis-error-bg"
                      : "tw-border-dis-field-edge tw-bg-dis-field hover:tw-bg-dis-field-hover"
                  }`,
                valueContainer: () =>
                  "tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-gap-2",
                input: () => "tw-m-0 tw-p-0 tw-text-base tw-text-dis-navy",
                placeholder: () => "tw-text-base tw-text-dis-placeholder",
                singleValue: () => "tw-truncate tw-text-base tw-text-dis-navy",
                indicatorsContainer: () => "tw-flex tw-items-center tw-gap-1",
                indicatorSeparator: () => "tw-hidden",
                dropdownIndicator: () =>
                  "tw-cursor-pointer tw-p-1 tw-text-dis-placeholder",
                clearIndicator: () =>
                  "tw-cursor-pointer tw-p-1 tw-text-dis-placeholder",
                menu: () =>
                  "tw-z-50 tw-mt-1 tw-overflow-hidden tw-rounded-lg tw-border tw-border-dis-border tw-bg-white tw-shadow-lg",
                menuList: () =>
                  "tw-divide-y tw-divide-dis-divider tw-overflow-y-auto [scrollbar-color:#c9dfec_transparent] [scrollbar-width:thin]",
                option: ({ isFocused, isSelected }) =>
                  `tw-cursor-pointer tw-px-3 tw-py-2.5 tw-text-base ${
                    isSelected
                      ? "tw-bg-dis-sky-tint tw-text-dis-navy"
                      : isFocused
                      ? "tw-bg-dis-field-hover tw-text-dis-navy"
                      : "tw-bg-white tw-text-dis-navy"
                  }`,
              }}
              placeholder={isLoading ? "Loading..." : placeholder}
              value={
                options.find((option) => option.value === field.value?.value) ||
                ""
              }
              options={options}
              isDisabled={disabled || isLoading}
              id={id}
              defaultValue=""
              instanceId={instanceId}
            />
            {showValidIcon && <ValidityCheck rightClassName="tw-right-9" />}
            {tooltipText && (
              <span className="tw-invisible tw-absolute tw-left-0 tw-top-[63px] tw-z-[999] tw-w-[min(90vw,413px)] tw-rounded-[11px] tw-bg-[#e8e8e8] tw-p-[7px] tw-text-gray-500 tw-opacity-0 tw-transition-opacity group-hover:tw-visible group-hover:tw-opacity-100">
                {tooltipText}
              </span>
            )}
          </>
        )}
      />
    </div>
  );
};

export default SelectInput;
